import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { useCountry } from '../context/CountryContext';

export const countryLabel = (c, lang) => (c?.name?.[lang] || c?.name?.en || c?.code || '').toString();

// Compare solo quando c'è più di un paese attivo.
export const CountrySelector = () => {
  const { country, countries, multi, setCountry } = useCountry();
  const { i18n } = useTranslation();
  if (!multi) return null;
  const lang = (i18n.language || 'it').split('-')[0];
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid="country-switcher" className="gap-1.5 text-xs flex">
          <MapPin size={14} />
          {country.toUpperCase()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {countries.map(c => (
          <DropdownMenuItem
            key={c.code}
            data-testid={`country-option-${c.code}`}
            onClick={() => setCountry(c.code)}
            className={c.code === country ? 'font-medium' : ''}
          >
            {countryLabel(c, lang)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
